import { toTitleCase } from "../../../../Utils/stringUtls";
import { disputeProcessing } from "../../OptionalFeatures/ChargebackAndDispute";
import ReviewAttribute from "../../../../Components/SharedComponent/ReviewAttribute/ReviewAttribute";

const ChargeBackAndDisputeOverview = ({ data }) => {
  const {
    of_cdp_processor,
    of_cdp_company_name,
    of_cdp_contact_name,
    of_cdp_job_title,
    of_cdp_phone_number,
    of_cdp_email,
  } = data["4_1"];
  return (
    <div className="forms-instance" style={{ color: "#111" }}>
      <div i2c-grid="grid grid" className="review-summary-gap">
        <div i2c-grid="12@md" className="review-summary-sub-heading">
          <div className="fw-700 font-bold">
            Chargeback & Dispute Processing
          </div>
        </div>
        <ReviewAttribute
          label="Chargeback & Dispute Processing"
          value={disputeProcessing[of_cdp_processor]?.label ?? "-"}
        />
        {of_cdp_processor === 2 && (
          <>
            <ReviewAttribute
              label="Company Name"
              value={of_cdp_company_name?.length ? toTitleCase(of_cdp_company_name) : "-"}
            />
            <ReviewAttribute
              label="Contact Name"
              value={of_cdp_contact_name?.length ? toTitleCase(of_cdp_contact_name) : "-"}
            />
            <ReviewAttribute
              label="Title"
              value={of_cdp_job_title?.length ? toTitleCase(of_cdp_job_title) : "-"}
            />
            <ReviewAttribute
              label="Company Phone"
              value={of_cdp_phone_number?.length ? toTitleCase(of_cdp_phone_number) : "-"}
            />
            <ReviewAttribute
              label="Email"
              value={of_cdp_email?.length ? toTitleCase(of_cdp_email) : "-"}
            />
          </>
        )}
      </div>
      <div className="divider-bottom mt-16"></div>
    </div>
  );
};
export default ChargeBackAndDisputeOverview;
